import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import Button from '../../../../components/elements/button';
import Icon from '../../../../components/icons';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import toast from 'react-hot-toast';
import { MASTER_DROPDOWN_PAGE_SIZE } from '../../../../_common/constant';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { getSelectedOption } from '../../../../_common/functions';
import FileUpload from '../../../../components/elements/form/fileUplaod';
import { Link } from 'react-router-dom';
import { useDialog } from '../../../../store/api/hooks/dialogHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';

interface FormProps {
    _ref?: any;
    editData?: any;
    onCreate?: () => void
    onCancel?: () => void
}
type FormValues = {
    returnPartsID: any;
    partsID: any;
    partsCode: any;
    name: any;
    partsDescription: any;
    vendorPartCode: any;
    partsStatusID: any;
    partsCategoryID: any;
    vendorID: any;
    facilityID: any;
    subFacilityID: any;
    aisle: any;
    bin: any;
    row: any;
    model: any;
    make: any;
    unitID: any;
    costPerUnit: any;
    pricePerUnit: any;
    currentStock: any;
    minStock: any;
    maxStock: any;
    spareImage: any;
};


const CreateFacilities: React.FC<FormProps> = ({ _ref, editData, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, register, handleSubmit, formState: { errors }, reset } = useForm<FormValues>();
    const spearPartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const assetAPI: any = useAssetsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const { confirm } = useDialog();
    const [spearPartsCode, setSpearPartsCode] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [partsStatusList, setPartsStatusList] = React.useState<any[]>([]);
    const [partsCategoryList, setPartsCategoryList] = React.useState<any[]>([]);
    const [vendorList, setVendorList] = React.useState<any[]>([]);
    const [unitList, setUnitList] = React.useState<any[]>([]);
    const [facilityList, setFacilityList] = React.useState<any[]>([]);
    const [subFacilityList, setSubFacilityList] = React.useState<any[]>([]);
    const [attachmentList, setAttachmentList] = React.useState<any[]>([]);
    const [working, setWorking] = useState<boolean>(false);
    const [partsImg, setPartsImg] = useState<any>(null);
    const [partsAttachment, setPartsAttachment] = useState<any>(null);

    let imgExt = ['.png', '.jpg', '.jpeg', '.webp'];

    const getPartsStatus = () => {
        showLoader();
        spearPartsAPI.getPartsStatus({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            let statusList = (resp?.sparePartsStatusList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.partsStatusID
                }
            }));
            setPartsStatusList(statusList);
            hideLoader();
        }, (error: any) => {
            setPartsStatusList([]);
            hideLoader();
        });
    }
    const getPartsCategoryList = () => {
        showLoader();
        spearPartsAPI.getSparePartsCategoryList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const catList = (resp?.sparePartsCategoryList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.partsCategoryID
                }
            }));
            console.log('catList=================', catList)
            setPartsCategoryList(catList);
            hideLoader();
        }, (error: any) => {
            setPartsCategoryList([]);
            hideLoader();
        });
    }
    const getvenderList = () => {
        showLoader();
        assetAPI.GetvenderList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const vendorList = (resp?.vendorList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.vendorID
                }
            }));
            setVendorList(vendorList);
            hideLoader();
        }, (error: any) => {
            setVendorList([]);
            hideLoader();
        });
    }
    const getPartsUnitList = () => {
        showLoader();
        spearPartsAPI.getPartsUnitList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const unitList = (resp?.sparePartsUOMList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.unitID
                }
            }));
            setUnitList(unitList);
            hideLoader();
        }, (error: any) => {
            setUnitList([]);
            hideLoader();
        });
    }

    const getPartsAttachments = () => {
        showLoader();
        spearPartsAPI.getPartsAttachments({ PartsID: editData.partsID }, (resp: any) => {
            const attachmentList = resp?.attachmentList ? resp?.attachmentList : [];
            setAttachmentList(attachmentList);
            hideLoader();
        }, (error: any) => {
            setAttachmentList([]);
            hideLoader();
        });
    }

    const getSpearPartsCode = () => {
        const payload = {};
        spearPartsAPI.getSpearPartsCode(payload, (resp: any) => {
            setSpearPartsCode(resp.code)
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    const formReset = () => {
        setAttachmentList([]);
        reset({
            partsID: '',
            partsCode: '',
            name: '',
            partsDescription: '',
            vendorPartCode: '',
            partsStatusID: '',
            partsCategoryID: '',
            vendorID: '',
            facilityID: '',
            subFacilityID: '',
            aisle: '',
            bin: '',
            row: '',
            model: '',
            make: '',
            unitID: '',
            costPerUnit: '',
            pricePerUnit: '',
            currentStock: '',
            minStock: '',
            maxStock: '',
            returnPartsID: '',
            spareImage: ''
        });
    }


    const onSubmit: SubmitHandler<FormValues> = data => {
        console.log("Submited data=================", data)
        setWorking(true);
        if (data.currentStock == '') {
            data.currentStock = 0;
        }
        let payload: any = {
            "partsCode": spearPartsCode, //
            "name": data.name,//
            "partsDescription": data.partsDescription,//
            "vendorPartCode": data.vendorPartCode,
            "partsStatusID": data.partsStatusID?.value,
            "partsCategoryID": data.partsCategoryID?.value,
            "vendorID": data.vendorID?.value,
            "facilityID": data.facilityID?.value,
            // "subFacilityID": data.subFacilityID,
            "aisle": data.aisle,
            "bin": data.bin,
            "row": data.row,
            "model": data.model,
            "make": data.make,
            "unitID": data.unitID?.value,
            "costPerUnit": data.costPerUnit,
            "pricePerUnit": data.pricePerUnit,
            "currentStock": data.currentStock,
            "minStock": data.minStock,
            "maxStock": data.maxStock
        }
        if (editData) {
            payload['partsID'] = editData.partsID;
        }
        showLoader();
        spearPartsAPI.saveSpearParts(payload, (resp: any) => {
            if (partsImg) {
                const formData = new FormData();
                formData.append('PartsID', resp.returnID);
                formData.append('InputFile', partsImg);
                savePartsImage(formData); // savePartsAttachments
            } else {
                onCreate();
                onCancel();
                console.log(resp, "Submited resp")
                toast.success(resp?.message)
                formReset();
                hideLoader();
                setWorking(false);
            }
            if (partsAttachment) {
                const formData = new FormData();
                formData.append('PartsID', resp.returnID);
                for (let i = 0; i < partsAttachment.length; i++) {
                    formData.append('InputFile' + i, partsAttachment[i]);
                }

                savePartsAttachments(formData); // savePartsAttachments
            }

        }, (error: any) => {
            console.log('error =>', error);
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    };

    useEffect(() => {
        getPartsStatus();
        getPartsCategoryList();
        getvenderList();
        getPartsUnitList();
        getSpearPartsCode();
        getfacilitylist();
    }, []);

    // useEffect(() => {
    // 	if (_ref?.current) {
    // 		_ref.current.reset = formReset;
    // 	}
    // }, [_ref])

    useEffect(() => {
        if (editData) {
            setSpearPartsCode(editData.partsCode);
            reset({
                partsID: editData.partsID,
                partsCode: editData.partsCode,
                name: editData.sparePartsName,
                partsDescription: editData.partsDescription,
                vendorPartCode: editData.vendorPartCode,
                partsStatusID: getSelectedOption(editData.partsStatusID, partsStatusList),
                partsCategoryID: getSelectedOption(editData.partsCategoryID, partsCategoryList),
                vendorID: getSelectedOption(editData.vendorID, vendorList),
                facilityID: getSelectedOption(editData.facilityID, facilityoption),
                // subFacilityID: editData.subFacilityID,
                aisle: editData.aisle,
                bin: editData.bin,
                row: editData.row,
                // model: editData.model,
                // make: editData.make,
                unitID: getSelectedOption(editData.unitID, unitList),
                costPerUnit: editData.costPerUnit,
                pricePerUnit: editData.pricePerUnit,
                currentStock: editData.currenctStock,
                minStock: editData.minStock,
                maxStock: editData.maxStock,
                spareImage: editData.imageFullPath
            });
            getPartsAttachments();

            let qrList: any = [];
            qrList.push({ sparePartsID: editData.partsID, qty: 1 });
            const payload = { qrSparePartsList: qrList, sparePartsNameInQR: true };
            spearPartsAPI.ExportQrCode(payload, (resp: any) => {
                //console.log(resp);
            },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );


        } else {
            formReset();
            if (_ref?.current) {
                _ref.current.reset = formReset;
            }
        }
    }, [_ref, editData, partsStatusList, partsCategoryList, vendorList, unitList, facilityoption]);

    const savePartsAttachments = (data: any) => {
        showLoader();
        spearPartsAPI.savePartsAttachments(data, (resp: any) => {
            if (editData) {
                getPartsAttachments();
            }
            hideLoader();
            setWorking(false);
        }, (error: any) => {
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    }

    const savePartsImage = (data: any) => {
        showLoader();
        spearPartsAPI.savePartsImage(data, (resp: any) => {
            onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();
            setWorking(false);
        }, (error: any) => {
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    }

    const changeImgHandler = (e: any) => {
        setPartsImg(e.target.files[0]);
        if (editData) {
            const formData = new FormData();
            formData.append('PartsID', editData.partsID);
            formData.append('InputFile', e.target.files[0]);
            //savePartsImage(formData); // savePartsAttachments
        }
    }

    const changeAttachmentHandler = (e: any) => {
        setPartsAttachment(e.target.files);

        if (editData) {
            const formData = new FormData();
            formData.append('PartsID', editData.partsID);
            for (let i = 0; i < e.target.files.length; i++) {
                formData.append('InputFile' + i, e.target.files[i]);
            }
            //  formData.append('InputFile', e.target.files[0]);
            savePartsAttachments(formData); // savePartsAttachments
        }
    }



    const fileDeleteHandler = (item: any) => {
        confirm({
            type: 'delete',
            title: 'Delete Attachment',
            message: 'Are you sure you want to delete this Parts Attachment?',
            onConfirm: () => {
                spearPartsAPI.deletePartsAttachments({ PartsAttachmentID: item?.partsImageID }, (resp: any) => {
                    toast.success('Attachment deleted successfully');
                    getPartsAttachments();
                }, (error: any) => {
                    console.log('error =>', error);
                    toast.error(error);
                });
            }
        });
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className='flex flex-col h-full'>
            <div className='flex-1 overflow-auto'>
                <h4 className='font-semibold text-[0.938rem] pb-4 uppercase'>Basic Information</h4>
                <div className='bg-green-50 py-2 px-3'>
                    <h6 className='text-[0.813rem] font-semibold'>Part Code</h6>
                    <div className='p-2  rounded-md inline-block mt-2'>{spearPartsCode}</div>
                </div>

                <div className='grid  gap-2'>
                    <Controller
                        name='vendorPartCode'
                        control={control}
                        //rules={{ required: 'Vendor Part Code Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Vendor Part Code'
                                type='text'
                                value={value}
                                onChange={onChange}
                                // required
                                placeholder='Write Vendor Part Code Here'
                                error={errors.vendorPartCode?.message as any}
                            />
                        )}
                    />

                </div>

                <Controller
                    name='name'
                    rules={{ required: 'Part Name Reuired' }}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label='Part Name'
                            type='text'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Write Part Name  '
                            error={errors.name?.message as any}
                        />
                    )}
                />
                <Controller
                    name='partsDescription'
                    control={control}
                    //   rules={{ required: 'Description Reuired' }}
                    render={({ field: { value, onChange } }) => (
                        <Teaxtarea
                            label='Description'
                            value={value}
                            onChange={onChange}
                            //  required
                            placeholder='Description'
                            error={errors.partsDescription?.message as any}
                        />
                    )}
                />

                <div className={`grid ${editData ? '' : ''} gap-2`}>
                    <Controller
                        name='spareImage'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <FileUpload
                                label='Add Image'
                                accept=".jpg, .jpeg, .png"
                                value={value}
                                onChange={(e: any) => {
                                    changeImgHandler(e);
                                    onChange(e.target.files[0])
                                }}
                                placeholder='Choose Parts Attachment'
                            />
                        )}
                    />
                </div>

                <Controller
                    name='partsStatusID'
                    control={control}
                    rules={{ required: 'Status Reuired' }}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Status'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Choose Status'
                            options={partsStatusList}
                            error={errors.partsStatusID?.message as any}
                        />
                    )}
                />

                <h4 className='font-semibold text-[0.938rem] pb-8 uppercase'>GROUP Information</h4>
                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name='partsCategoryID'
                        control={control}
                        //  rules={{ required: 'Category Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Category'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Category'
                                className='mt-0'
                                //     required
                                options={partsCategoryList}
                                error={errors.partsCategoryID?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name='vendorID'
                        control={control}
                        //    rules={{ required: 'Vendor Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Vendor'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Vendor'
                                className='mt-0'
                                //   required
                                options={vendorList}
                                error={errors.vendorID?.message as any}
                            />
                        )}
                    />
                </div>


                <h4 className='font-semibold text-[0.938rem] pb-8 uppercase'>Facility Information</h4>
                <div className='grid gap-2'>
                    <Controller
                        name="facilityID"
                        control={control}
                        rules={{ required: "Facility is required" }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Location"
                                value={value}
                                onChange={onChange}
                                required
                                placeholder="Choose Facility"
                                options={facilityoption}
                                error={errors.facilityID?.message as any}
                            />
                        )}
                    />
                </div>
                {/* <h4 className='font-semibold text-[0.938rem] pb-8 uppercase'>Location Information</h4> */}

                {/* <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name='aisle'
                        control={control}
                        //  rules={{ required: 'Aisle Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Aisle'
                                type='text'
                                value={value}
                                onChange={onChange}
                                //  required
                                placeholder='Aisle'
                                error={errors.aisle?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name='bin'
                        control={control}
                        //  rules={{ required: 'Bin Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Bin'
                                type='text'
                                value={value}
                                onChange={onChange}
                                //  required
                                placeholder='Bin'
                                error={errors.bin?.message as any}
                            />
                        )}
                    />
                </div> */}
                {/* <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name='make'
                        control={control}
                        // rules={{ required: 'Make Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Make'
                                type='text'
                                value={value}
                                onChange={onChange}
                                //  required
                                placeholder='Make'
                                error={errors.make?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name='model'
                        control={control}
                        // rules={{ required: 'Model Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Model'
                                type='text'
                                value={value}
                                onChange={onChange}
                                //  required
                                placeholder='Model'
                                error={errors.model?.message as any}
                            />
                        )}
                    />
                </div> */}
                <h4 className='font-semibold text-[0.938rem] pb-8 uppercase'>Financial</h4>
                <Controller
                    name='unitID'
                    control={control}
                    rules={{ required: 'Unit Reuired' }}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Unit'
                            value={value}
                            onChange={onChange}
                            placeholder='Choose Unit'
                            className='mt-0'
                            required
                            options={unitList ? unitList : []}
                            error={errors.unitID?.message as any}
                        />
                    )}
                />
                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name='costPerUnit'
                        control={control}
                        // rules={{ required: 'Cost Per Unit Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Cost per Unit'
                                type='number'
                                value={value}
                                onChange={onChange}
                                //  required
                                placeholder='0.00'
                                error={errors.costPerUnit?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name='currentStock'
                        control={control}
                        //  rules={{ required: 'Current Stock Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Current Stock'
                                type='number'
                                value={value}
                                onChange={onChange}
                                //     required
                                placeholder='0.00'
                                error={errors.currentStock?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name='minStock'
                        control={control}
                        // rules={{ required: 'Min Stock Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Min. Stock'
                                type='number'
                                value={value}
                                onChange={onChange}
                                //   required
                                placeholder='0.00'
                                error={errors.minStock?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name='maxStock'
                        control={control}
                        //  rules={{ required: 'Max Stock Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Max. Stock'
                                type='number'
                                value={value}
                                onChange={onChange}
                                //   required
                                placeholder='0.00'
                                error={errors.maxStock?.message as any}
                            />
                        )}
                    />
                </div>

                {/* <div className='grid grid-cols-2 gap-2'>
                    <div className="bg-green-50 py-2 px-3"><h6 className="text-[0.813rem] font-semibold">QR Code</h6>
                        <div className="p-2 bg-white rounded-md inline-block mt-2"><img className='' src={qrImg} alt="" /></div>
                    </div>
                    <div>
                        <div className='w-full mb-2 p-1 border border-gray-300 rounded-md text-center min-h-20'>
                            <img className='' src={partsImg} alt="" />
                        </div>
                        <Controller
                            name='drop'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label='Add Image'
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder='Choose'
                                    className='mt-0'
                                    options={[]}
                                />
                            )}
                        />
                    </div>
                </div> */}
                {
                    // editData && 
                    <div className=' '>
                        <Controller
                            name='returnPartsID'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <FileUpload
                                    label='Select Parts Attachment'
                                    accept='.jpg, .jpeg, .png, application/pdf'
                                    isMulti={true}
                                    value={value}
                                    onChange={(e: any) => {
                                        changeAttachmentHandler(e);
                                        onChange(e.target.files[0])
                                    }}
                                    placeholder='Choose Parts Attachment'
                                />
                            )}
                        />
                    </div>
                }

                {
                    attachmentList && attachmentList.length > 0 && <div  >
                        <h4 className='font-semibold text-[0.938rem] pb-4 uppercase'>Files</h4>
                        <div className='grid grid-cols-5 gap-3'>
                            {
                                attachmentList.map((item: any, index: number) => {
                                    const found = imgExt.some((word) => item.originalFileName.includes(word));
                                    return (
                                        <div key={`attachmentList${index}`} className='border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative'>
                                            <Link to={item.fullFilePath} target='_blank'>
                                                {found ?
                                                    <img src={item.fullFilePath} alt={item.originalFileName} className="max-w-full max-h-20" />
                                                    : item.originalFileName
                                                }
                                            </Link>
                                            {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}
                                            <Icon name='close' size={0.70} onClick={() => fileDeleteHandler(item)} className='ms-2 text-[#F31260] p-1 rounded-full bg-[#E5BDCB] absolute -top-2 -right-2' />
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                }


            </div>
            <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2'>
                <Button type="button" theme='secondary' working={working} onClick={() => {
                    formReset();
                    onCancel();
                }}>Cancel</Button>
                <Button type="submit" working={working}>Save</Button>
            </div>

            {/* <input id="assetName" {...register('assetName', { required: true })} />
            {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div> */}

            {/* <button type="submit">Create Asset</button> */}
        </form>
    );
};

export default CreateFacilities;